import Flex from '@/components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col } from 'react-bootstrap';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { ReactNode } from 'react';

type Props = {
  title?: ReactNode;
  color?: string;
  text?: ReactNode;
  icon: IconProp;
  sm?: number;
  md?: number;
  xs?: number;
};

const IconWithLabel = ({
  title,
  color,
  text,
  icon,
  sm = 12,
  md = 6,
  xs = 6
}: Props) => {
  return (
    <Col xs={xs} sm={sm} md={md}>
      <Flex className="position-relative">
        <div className="icon-item icon-item-md border rounded-3 shadow-none me-2">
          <FontAwesomeIcon
            size="lg"
            icon={icon}
            style={{
              color
            }}
          />
        </div>
        <div className="flex-1">
          <h6 className="mb-1 fw-bold text-700">{title}</h6>
          <p
            className={`mb-0 fs-0 ${text ? 'text-900 fw-medium' : 'text-danger fw-light'}`}
          >
            {text ? text : 'نداره'}
          </p>
        </div>
      </Flex>
    </Col>
  );
};

export default IconWithLabel;
